'use client';

import type { ReactNode } from 'react';
import { IoClose } from 'react-icons/io5';
import { MdOutlineKeyboardArrowLeft } from 'react-icons/md';

import {
  portfolioModalCloseButtonClass,
  portfolioModalDescriptionClass,
  portfolioModalHeaderClass,
  portfolioModalTitleTextClass,
} from './modalStyles';

interface PortfolioModalHeaderProps {
  title: string;
  description?: string;
  onClose: () => void;
  back?: {
    label: string;
    onClick: () => void;
  };
  children?: ReactNode;
}

export const PortfolioModalHeader = ({ title, description, onClose, back, children }: PortfolioModalHeaderProps) => {
  if (back) {
    return (
      <div className="shrink-0 border-b border-slate-200 bg-white px-5 py-3.5">
        <div className="flex h-9 items-center justify-between gap-3">
          <button
            type="button"
            className="inline-flex h-9 items-center gap-0.5 text-sm font-semibold text-bzblue-700 hover:text-bzblue-800"
            onClick={back.onClick}
          >
            <MdOutlineKeyboardArrowLeft size={20} className="-ml-1 shrink-0" />
            {back.label}
          </button>
          <button type="button" aria-label="Close" className={portfolioModalCloseButtonClass} onClick={onClose}>
            <IoClose size={18} />
          </button>
        </div>
        <div className="mt-2">
          <h2 id="modalTitle" className={portfolioModalTitleTextClass}>
            {title}
          </h2>
          {description ? <p className={`mt-1 ${portfolioModalDescriptionClass}`}>{description}</p> : null}
        </div>
      </div>
    );
  }

  return (
    <div className={`${portfolioModalHeaderClass} items-center`}>
      <div className="min-w-0">
        {children}
        <h2 id="modalTitle" className={portfolioModalTitleTextClass}>
          {title}
        </h2>
        {description ? <p className={`mt-0.5 ${portfolioModalDescriptionClass}`}>{description}</p> : null}
      </div>
      <button type="button" aria-label="Close" className={portfolioModalCloseButtonClass} onClick={onClose}>
        <IoClose size={18} />
      </button>
    </div>
  );
};
